/**
 * @param {HitagiChatUser} user1
 * @param {HitagiChatUser} user2
 * @returns {number}
 */
export function userSortCallbackAlpha(user1, user2) {
    var user1Nick = user1.nick.toLocaleLowerCase(),
        user2Nick = user2.nick.toLocaleLowerCase();

    return user1Nick === user2Nick ? 0 : (user1Nick > user2Nick ? 1 : -1);
}

/**
 * @param {HitagiChatUser} user1
 * @param {HitagiChatUser} user2
 * @returns {number}
 */
export function userSortCallbackAlpha2(user1, user2) {
    return user1.nick === user2.nick ? 0 : (user1.nick > user2.nick ? -1 : 1);
}

/**
 * @this {HitagiChatUser|BobTVUser} Current user
 *
 * @param {HitagiChatUser} user1
 * @param {HitagiChatUser} user2
 *
 * @returns {number}
 */
export function userSortCallbackFollowees(user1, user2) {
    var followeeIndex,
        user1Followee = false,
        user2Followee = false;

    var followees = this.followees;

    for (followeeIndex in followees) {
        if (followees[followeeIndex] === user1.uid) user1Followee = true;
        else if (followees[followeeIndex] === user2.uid) user2Followee = true;
    }

    var user1Nick = user1.nick.toLocaleLowerCase(),
        user2Nick = user2.nick.toLocaleLowerCase();

    if (user1Followee) {
        return user2Followee ? (user1Nick > user2Nick ? 1 : -1) : -1;
    } else {
        return user2Followee ? 1 : (user1Nick > user2Nick ? 1 : -1);
    }
}

/**
 * @param {HitagiChatUser} user1
 * @param {HitagiChatUser} user2
 * @returns {number}
 */
export function userSortCallbackGender(user1, user2) {
    var user1Gender = user1.gender || 0;
    var user2Gender = user2.gender || 0;

    if(user1Gender === user2Gender) {
        var user1Nick = user1.nick.toLocaleLowerCase(),
            user2Nick = user2.nick.toLocaleLowerCase();

        return user1Nick === user2Nick ? 0 : (user1Nick > user2Nick ? 1 : -1);
    }

    var genderWeights = {
        1: 1,
        2: 4, // females on top
        3: 2,
        4: 3,
        0: 0 // anonymous
    };

    var user1genderWeight = genderWeights[user1Gender],
        user2genderWeight = genderWeights[user2Gender];

    return user1genderWeight > user2genderWeight ? -1 : 1;

}

/**
 * @param {HitagiChatUser} user1
 * @param {HitagiChatUser} user2
 * @returns {number}
 */
export function userSortCallbackStatus(user1, user2) {

    var user1Weight = 1;
    if (user1.member_type >= 0) user1Weight = 2;
    if (user1.certified) user1Weight = 3;
    if (user1.member_type >= 2) user1Weight = 4;

    var user2Weight = 1;
    if (user2.member_type >= 0) user2Weight = 2;
    if (user2.certified) user2Weight = 3;
    if (user2.member_type >= 2) user2Weight = 4;

    if(user1Weight === user2Weight) {
        var user1Nick = user1.nick.toLocaleLowerCase(),
            user2Nick = user2.nick.toLocaleLowerCase();

        return user1Nick === user2Nick ? 0 : (user1Nick > user2Nick ? 1 : -1);
    }

    return user1Weight > user2Weight ? -1 : 1;
}

/**
 * @this object[] Watching me records
 *
 * @param {HitagiChatUser} user1
 * @param {HitagiChatUser} user2
 * @return {number}
 */
export function userSortCallbackWatching(user1, user2) {
    var watchingMe = this;

    var user1Watching = watchingMe.hasOwnProperty(user1.ufrag) ? !!watchingMe[user1.ufrag] : false,
        user2Watching = watchingMe.hasOwnProperty(user2.ufrag) ? !!watchingMe[user2.ufrag] : false;

    if(user1Watching === user2Watching) {
        var user1Nick = user1.nick.toLocaleLowerCase(),
            user2Nick = user2.nick.toLocaleLowerCase();

        return user1Nick === user2Nick ? 0 : (user1Nick > user2Nick ? 1 : -1);
    }

    return user1Watching > user2Watching ? -1 : 1;
}

export const USER_SORTING_SELECT = 'USER_SORTING_SELECT';
export const USER_SORT_ALPHA = 'USER_SORT_ALPHA';
export const USER_SORT_GENDER = 'USER_SORT_GENDER';
export const USER_SORT_WATCHING = 'USER_SORT_WATCHING';
export const USER_SORT_FOLLOWEES = 'USER_SORT_FOLLOWEES';
export const USER_SORT_STATUS = 'USER_SORT_STATUS';

export const defaultUserSorting = USER_SORT_GENDER;

export function getUserSorting(state) {
    var result,
        callback;

    switch (state.userSorting) {
        case USER_SORT_ALPHA:
            result = userSortCallbackAlpha;
            break;
        case USER_SORT_WATCHING:
            if(state.watchingMe) {
                callback = userSortCallbackWatching.bind(state.watchingMe);
                result = callback;
            }
            break;
        case USER_SORT_FOLLOWEES:
            if(state.currentUser) {
                callback = userSortCallbackFollowees.bind(state.currentUser);
                result = callback;
            }
            break;
        case USER_SORT_GENDER:
            result = userSortCallbackGender;
            break;
        case USER_SORT_STATUS:
            result = userSortCallbackStatus;
            break;
        default:
            result = defaultUserSorting;
    }

    return result;
}

export const ROOM_CLIENT_LIST = 'ROOM_CLIENT_LIST';
export const ROOM_CLIENT_LOGIN = 'ROOM_CLIENT_LOGIN';
export const ROOM_CLIENT_UPDATE = 'ROOM_CLIENT_UPDATE';
export const ROOM_CLIENT_LOGOUT = 'ROOM_CLIENT_LOGOUT';
export const ROOM_CLIENT_UPDATE_OFFLINE = 'ROOM_CLIENT_UPDATE_OFFLINE';



// WEBPACK FOOTER //
// ./src/constants/users.js